import { t } from '@lingui/macro';
import React from 'react';

import Alert from './Alert';
import { PasswordDigestAlertProps } from './types';

/**
 * PasswordDigestAlert Component
 * Shows alert for legacy password digest migration
 * Displayed when transitioning from old password system to new passkey system
 */
const PasswordDigestAlert: React.FunctionComponent<PasswordDigestAlertProps> = ({
  libraryName,
  displayExpirationDate,
  showNewPasskeyField,
  onUpdateClick
}) => {
  const headerText =
   t`For security reasons, the guest passkey for this ${libraryName} will expire on ${displayExpirationDate}.`;

  const messageLines = [
    t`New guest passkeys will require an expiration date.`,
    showNewPasskeyField ? '' : t`UPDATE_BUTTON and share to guest users that you'd like to continue to give access to.`
  ].filter((line) => line !== ''); // Remove empty lines when input is shown

  return (
    <Alert
      headerText={headerText}
      messageLines={messageLines}
      onUpdateClick={onUpdateClick}
      showUpdateButton={!showNewPasskeyField}
    />
  );
};

export default PasswordDigestAlert;
